<template>
  <div>
    <h3>仪器介绍</h3>
    <b-card-group columns>
      <b-card
        v-for="(item, index) in facilities"
        v-bind:key="index"
        :title="item.name"
        :img-src="item.image"
        img-alt="item.name"
        img-top
        style="max-width: 20rem"
        class="mb-2"
      >
        <b-card-text>
          {{ item.desc }}
        </b-card-text>

        <router-link :to="'/facility/detail?id=' + item.id">
          <b-button variant="outline-secondary" size="sm">
            了解详情 &#187;
          </b-button>
        </router-link>
      </b-card>
    </b-card-group>
    <div class="overflow-auto">
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-text="首页"
          prev-text="上一页"
          next-text="下一页"
          last-text="尾页"
          align="center"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      facilities: [],
      rows: 0,
      currentPage: 1,
      perPage: 6,
    };
  },
  created: function () {
    this.get_facility_list();
  },
  watch: {
    currentPage: function (val) {
      let url =
        "facility/list?ordering=index&p=" + val + "&page_size=" + this.perPage;
      this.$http.get(url).then((response) => {
        this.facilities = response.data.results;
      });
    },
  },
  methods: {
    get_facility_list: function () {
      let url =
        "facility/list?ordering=index&p=" +
        this.currentPage +
        "&page_size=" +
        this.perPage;
      this.$http.get(url).then((response) => {
        this.facilities = response.data.results;
        this.rows = response.data.count;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.card-columns {
  padding-bottom: 30px;
}
.card {
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.15), 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}
.card-text {
  font-size: 14px;
}
.mb-2 {
  margin-bottom: 1.5rem !important;
}
.btn-outline-secondary {
  font-size: 12px;
}
</style>
